module.exports = __webpack_public_path__ + "static/media/sprod.c6f49991.png";